import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import BottomNav from "@/components/BottomNav";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AiMatch from "@/pages/AiMatch";
import SeekerDashboard from "@/pages/SeekerDashboard";
import EmployerDashboard from "@/pages/EmployerDashboard";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ilanlar" element={<Jobs />} />
            <Route path="/ilan/:slug" element={<JobDetail />} />
            <Route path="/sirketler" element={<Companies />} />
            <Route path="/sirket/:id" element={<CompanyDetail />} />
            <Route path="/ai-eslestirme" element={<AiMatch />} />
            <Route path="/giris" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/panel" element={<ProtectedRoute roles={["jobseeker"]}><SeekerDashboard /></ProtectedRoute>} />
            <Route path="/isveren" element={<ProtectedRoute roles={["employer", "admin"]}><EmployerDashboard /></ProtectedRoute>} />
            <Route path="/adc" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <BottomNav />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
